import { UIUrvalConditionObjectType } from 'src/Types/UrvalTypes';

export const setCondition = <T extends UIUrvalConditionObjectType>(
  newCondition: T['condition'],
  conditionObject: T
): T => {
  const newConditionObject: T = Object.assign({}, conditionObject);
  newConditionObject.condition = newCondition;
  return newConditionObject;
};

export const set = <K extends keyof T, V extends T[K], T extends {}>(
  key: K,
  newValue: V,
  obj: T
): T => Object.assign({}, obj, { [key]: newValue });

export const conditionObjectHasValue = (
  conditionObject: UIUrvalConditionObjectType
) => {
  if (conditionObject.type === 'Boolean') {
    return conditionObject.condition.no || conditionObject.condition.yes;
  } else if (
    conditionObject.type === 'Checklist' ||
    conditionObject.type === 'TypeTree'
  ) {
    return conditionObject.condition.length > 0;
  } else if (
    conditionObject.type === 'Numeric' ||
    conditionObject.type === 'String'
  ) {
    return conditionObject.condition[0].values.some(
      value => Boolean(value.value) || Boolean(value.toValue)
    );
  } else if (conditionObject.type === 'Extended') {
    return conditionObject.condition[0] != null;
  } else {
    return false;
  }
};
